<div class="solo set-link-activity">
    <section class="child">
        <header ng-show="!showLabel || showLabel === 'true'">
            <h1>{{localize(activity.Trigger.FriendlyName)}}</h1>
        </header>
        <p>{{'setLink.description'|translate}}</p>
        <input name="activityLink" type="text" ng-model="activity.Link" /><button class="test-button" ng-click="testLink()">{{'setLink.test'|translate}}</button>
    </section>
</div>